import React from 'react';
import { apiPost, apiGet, getHostApi } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { layoutActions } from "../../../store/layoutStore";
import { popupActions } from '../../../store/popupStore';
import { toast } from '../../common/toast';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import BbCheckbox from '../../styling/bbCheckbox';
import classnames from 'classnames';
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import Paging from "../../common/pagingComponent";
import RelationLink from "../../reportSections/relations/relationLink";

import './conflictOfInterest.scss';

class ConflictOfInterestListForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSize: 30,
            index: 1,
            data: [],
            totalCount: null,
            isLoading: true,
            selectAll: false,
            selected: [],
            sortBy: "Name",
            error: null
        };
    }

    render() {
        return (

            <div className='card card-special'>
                <div className='card-body'>
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        apiGet(`${getHostApi()}/api/conflict-of-interest/${this.props.type}/list`,
            { sortBy: this.state.sortBy, pageSize: this.state.pageSize, startIndex: (this.state.index - 1) * this.state.pageSize },
            (data) => this.success(data.data),
            (err) => this.onError(err));
    }

    addSubject() {
        this.props.history.push(`/search/conflictOfInterest/${this.props.type}-list/add`);
    }

    orderBy(orderBy) {
        if (this.state.sortBy === orderBy)
            orderBy = `${orderBy} DESC`;
        this.setState({ sortBy: orderBy }, () => this.getData());

    }

    onChangeCheckBox(e, id) {
        var selected = [];
        if (e) {
            selected = this.state.selected.concat(id);
            this.setState({ selected: selected, selectAll: selected.length === this.state.data.length });
        }
        else {
            selected = this.state.selected.filter(item => item !== id)
            this.setState({ selected: selected, selectAll: false });
        }

    }

    selectAll() {
        var selected = [];
        if (this.state.selectAll === false) {
            this.state.data.forEach(item => {
                selected = selected.concat(item.id)
            });
        }

        this.setState({ selectAll: this.state.selectAll === false, selected: selected });
    }

    onPageClick = (page) => {
        this.setState({ index: page }, () => { this.getData() })
    }

    onError(err) {
        this.setState({ isLoading: false, error: err });
    }
    success(data) {
        this.setState({ data: data.items, totalCount: data.total, isLoading: false, error: null });
    }

    exportToCsv() {
        window.open(`/files/conflict-of-interest/${this.props.type}/${this.state.sortBy}`, "_blank");
    }

    deleteConfirm = () => {
        this.props.showPopup('confirmationPopup', {
            title: this.props.translate('Monitoring.Overview.DeleteItemsPermanentlyTitle'),
            htmlBody: this.props.translate('ConflictOfInterest.DeleteSelected'),
            yesButtonText: this.props.translate('Common.Button.Delete'),
            yesButtonFunction: () => {
                this.props.hidePopup();
                this.deleteSelected();
            },
            noButtonText: this.props.translate('Common.Button.Cancel'),
            open: true,
            close: () => this.props.hidePopup()
        });
    }

    deleteSelected() {
        if (this.state.selectAll) {
            apiPost(`${getHostApi()}/api/conflict-of-interest/${this.props.type}/clear`, null, null,
                () => this.setState({ selectAll: false, selected: [], error: null }, toast(this.props.translate("ConflictOfInterest.ListUpdatedSubjects"), "success"), this.getData()),
                (e) => this.onError(e));
        }
        else {
            if (!isNullOrUndefined(this.state.selected) && this.state.selected.length > 0) {
                apiPost(`${getHostApi()}/api/conflict-of-interest/${this.props.type}/delete`, null,
                    this.state.selected,
                    () => this.setState({ selectAll: false, selected: [], error: null }, toast(this.props.translate("ConflictOfInterest.ListUpdatedSubjects"), "success"), this.getData()),
                    (e) => this.onError(e));
            }
        }
    }

    renderTable() {
        return (
            <React.Fragment>
                <div className="count-subject"><Translate id="Search.ConflictOfInterest.Count" />: {this.state.totalCount}</div>
                {!this.state.isLoading && this.state.data.length > 0 &&
                    <div className="responsive-table">
                        <table className="table table-report-section table-marketing-list">
                            <thead>
                                <tr>
                                    <th className="with-pointer" style={{ width: "15%" }} onClick={() => this.orderBy("ICO")}><Translate id="Search.Common.CompanyId" /></th>
                                    <th className="with-pointer" style={{ width: "30%" }} onClick={() => this.orderBy("Name")}><Translate id="Search.Common.CompanyName" /></th>
                                    <th className="with-pointer" style={{ width: "20%" }} onClick={() => this.orderBy("PrimaryAttribute")}><Translate id="Search.ConflictOfInterest.RegistrationCountry" /></th>
                                    {this.props.type === "reference" && <th className="with-pointer" onClick={() => this.orderBy("ApplicableDate")}><Translate id="Search.ConflictOfInterest.ApplicableDate" /></th>}
                                    <th className="with-pointer" onClick={() => this.orderBy("InsertDate")}><Translate id="Search.ConflictOfInterest.InsertDate" /></th>
                                    <th className="with-pointer" onClick={() => this.selectAll()} style={{ textAlign: "right" }}><div className="coi-select-all-wrapper"><BbCheckbox style={{ fontWeight: 600 }} id="conflictOfInterest-list-all" value={this.isAllChecked()} onChange={() => this.selectAll()} /></div></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data.map((item) => {
                                    return (
                                        <tr key={item.id} className='colorize'>
                                            <td>{item.ico}</td>
                                            <td><RelationLink entityId={item.entityId} reports={item.reports} entityName={item.name} showOnMobile={true} /></td>
                                            <td>{item.registrationCountry}</td>
                                            {this.props.type === "reference" && <td>{item.applicableDateFormated}</td>}
                                            <td>{item.insertDateFormated}</td>
                                            <td className="coi-select-wrapper" ><BbCheckbox style={{ display: "inline-flex", minHeight: "0px", lineHeight: "3em", verticalAlign: "middle" }}
                                                id={`coi-${item.id}`}
                                                name={`coi-${item.id}`}
                                                value={this.state.selected.includes(item.id)}
                                                onChange={e => this.onChangeCheckBox(e, item.id)} /></td>
                                        </tr>
                                    )

                                })}
                            </tbody>
                        </table>
                    </div>
                }
                <div className="table-action-wrapper">
                    <div style={{ visibility: "hidden" }}>{<Translate id='Common.DeleteSelected' />}</div>
                    <div className="paging-wrapper">
                        <Paging selectedPage={this.state.index}
                            totalPages={Math.ceil(this.state.totalCount / this.state.pageSize)}
                            setPage={this.onPageClick} />
                    </div>
                    <div className="delete-wrapper">
                        <a className={classnames('link-functional', { 'is-disabled': (this.state.isLoading || this.state.selected.length === 0) })}
                            onClick={() => this.deleteConfirm()}
                        >
                            {<Translate id='Common.DeleteSelected' />}
                        </a>
                    </div>
                </div>
                <div className='columns m-0 is-centered has-text-centered'>
                    <div className='column is-narrow'>
                        <button className={classnames('bb-button is-primary gradient-1-secondary', { 'is-square': localStorage.locales_button_style === 'square' })}
                            type='submit'
                            style={{ fontWeight: 600 }}
                            disabled={this.state.isLoading}
                            onClick={() => this.exportToCsv(this.props.type)}
                        >
                            {this.state.isLoading ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Search.ConflictOfInterest.ExportToCsv' />}
                        </button>
                        <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                            type='submit'
                            style={{ fontWeight: 600 }}
                            disabled={this.state.isLoading}
                            onClick={() => this.addSubject()}
                        >
                            {this.state.isLoading ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Common.Button.Add.Subject' />}
                        </button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderNoData() {
        return (
            <>
                <NoDataComponent />
                <div className='columns m-0 is-centered has-text-centered'>
                    <div className='column is-narrow'>
                        <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                            type='submit'
                            style={{ fontWeight: 600 }}
                            disabled={this.state.isLoading}
                            onClick={() => this.addSubject()}
                        >
                            {this.state.isLoading ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Common.Button.Add.Subject' />}
                        </button>
                    </div>
                </div>
            </>
        );
    }

    isAllChecked = () => {
        if (this.state.selected.length === 0) { return false };
        if (this.state.selectAll) { return true };
        return null;
    }

    renderContent() {
        if (this.state.isLoading) {
            return <Circles />
        } else if (this.state.error) {
            let errorMessage = <Translate id={this.state.error.data.error.message || "UnhappyUser.InternalServerError"} options={{ renderInnerHtml: true }} />
            return <Message type="error" message={errorMessage} />
        }
        else {
            return (
                <>
                    {!this.state.isLoading && !isNullOrUndefined(this.state.data) && this.state.data.length > 0 ? this.renderTable() : this.renderNoData()}
                </>
            );
        }
    }
}

export default connect(
    state => ({ user: state.userContext }),
    dispatch => bindActionCreators({ ...layoutActions, ...popupActions }, dispatch)
)(withLocalize(withRouter(ConflictOfInterestListForms)));